import { LoaderByfi } from 'styles-byfi'

export default function FallbackLoader() {
  return (
    <div className="container-fluid">
      <LoaderByfi />
    </div>
  )
}
